import React from 'react';
import PropTypes from 'prop-types';

import { Decline } from 'components/Icons';
import useWorkflowGuard from 'hooks/useWorkflowGuard';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

const GeneralError = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);
  const errorMessage = useSelector((state) => get(state, 'error.message', 'We were unable to process your request.'));

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <Decline className="mb-4" />
      <p className="text-xl md:text-3xl font-semibold text-slate-800 mb-8 md:px-[115px]">
        Unfortunately, we were unable to process your application at this time.
      </p>

      {errorMessage ? (
        <p className="text-sm text-red-600 px-0 md:px-[115px] ">
          {errorMessage}
        </p>
      ) : null}
    </div>
  );
};

GeneralError.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default GeneralError;
